export default "__VITE_ASSET__DwJH6atF__"